function exactWords(query) {
  const text = query.trim();
  if (!text || text.length > 160 || !/^[\p{L}\p{N}\s._-]+$/u.test(text)) return "";
  const words = text.split(/\s+/);
  if (words.length > 12 || words.some(word => /^(AND|OR|NOT)$/i.test(word))) return "";
  return words.map(word => '"' + word + '"').join(" AND ");
}

function showOriginalQuery(root, original) {
  const input = root.querySelector("#VtSearchInput");
  if (input) input.value = original;
  const label = root.querySelector("[data-vt-search-query-label]");
  if (label) label.textContent = root.dataset.vtSearchLabel.replace("__VT_QUERY__", original);
  const inquiry = root.querySelector("[data-vt-search-inquiry]");
  if (inquiry) {
    const target = new URL(inquiry.href, location.href);
    const searchURL = new URL(location.pathname, location.origin);
    searchURL.searchParams.set("q", original);
    searchURL.searchParams.set("type", "product");
    target.searchParams.set("product_inquiry", root.dataset.vtSearchLabel.replace("__VT_QUERY__", original) + "\n" + searchURL);
    inquiry.href = target.href;
  }
  const exact = exactWords(original);
  root.querySelectorAll(".vts-results a[href]").forEach(link => {
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.searchParams.get("q") === exact) {
      url.searchParams.set("vt_query", original);
      link.href = url.href;
    }
  });
  root.querySelectorAll(".vts-results form").forEach(form => {
    if (form.querySelector('[name="q"]')?.value !== exact) return;
    let field = form.querySelector('[name="vt_query"]');
    if (!field) {
      field = document.createElement("input");
      field.type = "hidden";
      field.name = "vt_query";
      form.append(field);
    }
    field.value = original;
  });
}

async function restoreMissingResults(root) {
  if (root.dataset.vtSearchReady) return;
  root.dataset.vtSearchReady = "true";
  const current = new URL(location.href);
  const terms = root.dataset.vtSearchTerms || "";
  const original = current.searchParams.get("vt_query");
  if (original && exactWords(original) === terms) {
    showOriginalQuery(root, original);
    return;
  }
  const query = exactWords(terms);
  const results = root.querySelector(".vts-results");
  if (!results || Number(root.dataset.vtSearchCount) !== 0 || !query || current.searchParams.has("vt_query")) return;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  const stop = () => controller.abort();
  window.addEventListener("pagehide", stop, { once: true });
  const empty = results.querySelector(".vts-empty");
  const status = document.createElement("p");
  status.className = "vts-wrap";
  status.setAttribute("role", "status");
  status.textContent = root.dataset.vtSearchLoading;
  results.prepend(status);
  results.setAttribute("aria-busy", "true");
  if (empty) empty.hidden = true;
  try {
    current.searchParams.set("q", query);
    current.searchParams.set("section_id", root.dataset.vtSearchSection);
    const response = await fetch(current, { signal: controller.signal, headers: { accept: "text/html" } });
    if (!response.ok) throw new Error("SearchUnavailable");
    const html = new DOMParser().parseFromString(await response.text(), "text/html");
    const replacement = html.querySelector("[data-vt-search-section]");
    const replacementResults = replacement?.querySelector(".vts-results");
    if (Number(replacement?.dataset.vtSearchCount) > 0 && replacementResults) {
      results.replaceWith(replacementResults);
      root.dataset.vtSearchCount = replacement.dataset.vtSearchCount;
      const announcement = root.querySelector("[data-vt-search-status]");
      if (announcement) announcement.textContent = root.dataset.vtSearchCountLabel.replace("__VT_COUNT__", replacement.dataset.vtSearchCount);
      showOriginalQuery(root, terms);
      root.dispatchEvent(new CustomEvent('vt:results-updated', { bubbles: true }));
    }
  } catch {
  } finally {
    clearTimeout(timeout);
    window.removeEventListener("pagehide", stop);
    status.remove();
    results.removeAttribute("aria-busy");
    if (empty) empty.hidden = false;
  }
}

document.querySelectorAll("[data-vt-search-section]").forEach(restoreMissingResults);
document.addEventListener("shopify:section:load", event => {
  event.target.querySelectorAll("[data-vt-search-section]").forEach(restoreMissingResults);
});
